import {
    Container,
    Paper,
    Typography,
    Box,
    Button,
    FormControl,
    FormLabel,
    FormControlLabel,
    Radio,
    RadioGroup,
    TextField
} from "@mui/material";
import styles from "../../styles/backButton.module.scss";
import btnStyles from '../../styles/buttons.module.scss';
const today = new Date();

const maxDob = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
);


const maxDobString = maxDob.toISOString().split("T")[0];
const todayString = new Date().toISOString().split("T")[0];
export default function HealthAndSafetyForm({

    data,

    errors,

    handleChange,

    onBack,

    onContinue

}) {

    return (

            <Paper
                elevation={3}
                 sx={{
                    maxWidth: 1200,
                    mx: "auto",
                    mt: 4,
                    mb: 4,
                    px: { xs: 2, md: 4 },
                    py: 3,
                    borderRadius: 2
                }}
            >

                <Typography
                    variant="h4"
                    gutterBottom
                >

                    Health &amp; Safety

                </Typography>

                <Typography sx={{ mb: 4, color: "rgba(0,0,0,0.6)", }}>

                    Please answer the following questions regarding Visual Display Unit (VDU) use.

                </Typography>


                <Box
                    sx={{
                        display: "grid",
                        gap: 3
                    }}
                >

                    {/* VDU User */}

                    <FormControl
                        error={!!errors.isVduUser}
                    >

                        <FormLabel sx={{color: "rgba(0,0,0,1)"}}>

                            Are you a VDU user (at work)?

                        </FormLabel>

                        <RadioGroup
                            row
                            name="isVduUser"
                            value={data.isVduUser}
                            onChange={handleChange}
                        >

                            <FormControlLabel
                                value="true"
                                control={<Radio />}
                                label="Yes"
                            />

                            <FormControlLabel
                                value="false"
                                control={<Radio />}
                                label="No"
                            />

                        </RadioGroup>

                        {
                            errors.isVduUser &&
                            <Typography
                                color="error"
                                variant="caption"
                            >
                                {errors.isVduUser}
                            </Typography>
                        }

                    </FormControl>


                    {
                        data.isVduUser === "true" && (

                            <>

                                {/* Eye Test */}

                                <TextField

                                    label="Date of Latest Eye Test"
                                    type={data.vduLastEyeTestDate ? "date" : "text"}

                                    name="vduLastEyeTestDate"

                                    value={data.vduLastEyeTestDate}

                                    onChange={handleChange}
        


                                    onFocus={(e) => {
                                        e.target.type = "date";
                                    }}
                                    onBlur={(e) => {
                                        if (!e.target.value) {
                                            e.target.type = "text";
                                        }
                                    }}

                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    inputProps={{
                                        max: maxDobString,
                                        min: "1900-01-01"
                                    }}

                                    error={
                                        !!errors.vduLastEyeTestDate
                                    }

                                    helperText={
                                        errors.vduLastEyeTestDate
                                    }

                                />


                                {/* Glasses */}

                                <FormControl
                                    error={
                                        !!errors.vduGlassesIssued
                                    }
                                >

                                    <FormLabel sx={{color: "rgba(0,0,0,1)"}}>

                                        Have VDU glasses been issued?

                                    </FormLabel>

                                    <RadioGroup
                                        row
                                        name="vduGlassesIssued"
                                        value={
                                            data.vduGlassesIssued
                                        }
                                        onChange={handleChange}
                                    >

                                        <FormControlLabel
                                            value="true"
                                            control={<Radio />}
                                            label="Yes"
                                        />

                                        <FormControlLabel
                                            value="false"
                                            control={<Radio />}
                                            label="No"
                                        />

                                    </RadioGroup>

                                    {
                                        errors.vduGlassesIssued &&

                                        <Typography
                                            color="error"
                                            variant="caption"
                                        >

                                            {
                                                errors.vduGlassesIssued
                                            }

                                        </Typography>

                                    }

                                </FormControl>

                            </>

                        )

                    }

                </Box>


                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: 5
                    }}
                >

                    <Button
                        variant="contained"
                        onClick={onBack}
                        className={styles.backSingleBtn}
                        sx={{  mt: "20px", mb: "20px"}}
                    >
                        Back
                    </Button>
                    <Button
                       className={btnStyles.btnDesktop}
                        variant="contained"
                        size="large"
                        sx={{ textTransform: 'none' }}
                        onClick={onContinue}
                    >
                        Continue
                    </Button>

                </Box>

            </Paper>

    );

}